import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { ReservationService } from "../../../../services/reservation.service";
import { PlanService } from "../../../../services/plan.service";

@Component({
  selector: "page-reservation-change",
  templateUrl: "./index.component.html",
})
export class PageReservationChangeComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public reservationData: any = {};
  public activatedStation: any = {};
  public currentCancelRuleItem: any = {};
  public divisionData: any = {};
  public formGroup: FormGroup;

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    public authService: AuthService,
    public commonService: CommonService,
    public reservationService: ReservationService,
    public planService: PlanService
  ) {
    let self = this;
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();

    /* CUSTOM VALIDATOR */
    this.myValidator.isKana = function (control: AbstractControl): any {
      if (!self.commonService.isKana(control.value)) {
        return { isKana: true };
      }
      return null;
    };

    this.myValidator.isNumeric = function (control: AbstractControl): any {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };

    this.myValidator.menOrWomenOnly = function (index: number = -1) {
      return function (control: AbstractControl): any {
        if (index === -1) {
          return { required: true };
        }

        let sex = parseInt(control.value);

        if (
          self.reservationData.reservation.passenger_list[index].sex ==
          self.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          /* MALE */
          if (
            sex ==
            self.commonService.appConfig.reservation.defaultUserData.sexFemale
          ) {
            return { menOnly: true };
          }
        } else {
          /* FEMALE */
          if (
            sex ==
            self.commonService.appConfig.reservation.defaultUserData.sexMale
          ) {
            return { womenOnly: true };
          }
        }

        return null;
      };
    };

    this.myValidator.representativePhone = function (index: number = -1) {
      return function (control: AbstractControl): any {
        if (!self.formGroup || index === -1) {
          return { required: true };
        }

        let phone = control.value;

        if (
          self.formGroup.controls[`p_representative_${index + 1}`].value ==
          self.commonService.appConfig.reservation.passengerRepresentative
        ) {
          phone = String(phone).trim();
          if (phone == "") {
            return { required: true };
          } else if (phone.length < 10 || phone.length > 11) {
            return { minlength: true, maxlength: true };
          }
        }

        return null;
      };
    };

    this.myValidator.minAge = function (control: AbstractControl): any {
      let age = control.value;
      if (control.value && control.value != "") {
      } else {
        age = 0;
      }

      let minAgeData = self.reservationService.getMinAgeByOfficeCode(
        self.reservationData.reservation.bus_detail.office_code
      );

      /* CHECK HAS AT LEAST 1 minAgeData */
      if (
        minAgeData !=
        self.commonService.appConfig.reservation.passengerAgeLimit.min
      ) {
        /* RESET ALL AGE INPUTS */
        let keyPrefix = "p_age_";
        if (self.formGroup) {
          for (
            let i = 0;
            i < self.reservationData.reservation.passenger_list.length;
            i++
          ) {
            if (
              self.formGroup.controls[`${keyPrefix}${i + 1}`].value >=
              minAgeData
            ) {
              minAgeData =
                self.commonService.appConfig.reservation.passengerAgeLimit.min;
              break;
            }
          }

          /* RESET AGE VALIDATORS */
          for (
            let i = 0;
            i < self.reservationData.reservation.passenger_list.length;
            i++
          ) {
            self.formGroup.controls[`${keyPrefix}${i + 1}`].setValidators([
              Validators.required,
              self.myValidator.isNumeric,
              self.myValidator.minAge,
              Validators.max(self.tempData.maxAge),
            ]);
            if (
              self.formGroup.controls[`${keyPrefix}${i + 1}`].errors &&
              self.formGroup.controls[`${keyPrefix}${i + 1}`].errors.minAgeData
            ) {
              self.formGroup.controls[
                `${keyPrefix}${i + 1}`
              ].errors.minAgeData = minAgeData;
              if (
                self.formGroup.controls[`${keyPrefix}${i + 1}`].value >=
                minAgeData
              ) {
                self.formGroup.controls[`${keyPrefix}${i + 1}`].setErrors(null);
              }
            }
            self.formGroup.controls[`${keyPrefix}${i + 1}`].markAsUntouched();
          }
        }
      }
      /* END */

      if (parseInt(age) < minAgeData) {
        return { minAge: true, minAgeData: minAgeData };
      }
      return null;
    };
  }

  async ngOnInit() {
    /* COMMENTED FOR PUBLIC SEARCH CHECK IF NOT LOGGED IN */
    /* if (!this.authService.isLoggedIn()) {
            return this.commonService.redirectToRoute(this.commonService.routePaths.pageHomeNoParam);
        } */

    /* SET PAGE TITLE */
    this.commonService.setTitle(`予約を変更する | バスブックマーク`);

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();

    /* GET RESERVATION DATA */
    /* CHECK SAVED DATA */
    let reservationChangingData =
      this.reservationService.getReservationChangesData();
    if (
      !this._.isEmpty(reservationChangingData) &&
      reservationChangingData.reservationData.reservation.reservation_id ==
        this.activatedRoute.snapshot.paramMap.get("reservationID")
    ) {
      this.reservationData = reservationChangingData.reservationData;

      /* REFILL PASSENGER DATA */
      for (let [
        index,
        item,
      ] of this.reservationData.reservation.passenger_list.entries()) {
        let currentIndex = index + 1;

        item.board_initial = item.board_initial
          ? item.board_initial
          : item.board;
        item.board =
          reservationChangingData.passengerChangeData[
            `p_board_${currentIndex}`
          ];
        item.is_representative =
          reservationChangingData.passengerChangeData[
            `p_representative_${currentIndex}`
          ];
        item.mei_kana =
          reservationChangingData.passengerChangeData[`p_mei_${currentIndex}`];
        item.sei_kana =
          reservationChangingData.passengerChangeData[`p_sei_${currentIndex}`];
        item.age =
          reservationChangingData.passengerChangeData[`p_age_${currentIndex}`];
        item.tel1 =
          reservationChangingData.passengerChangeData[`p_tel1_${currentIndex}`];
        item.tel2 =
          reservationChangingData.passengerChangeData[`p_tel2_${currentIndex}`];
        item.tel3 =
          reservationChangingData.passengerChangeData[`p_tel3_${currentIndex}`];
      }
    } else {
      let reservationData = this.commonService.getData(
        "searchReservationDataDetail"
      );
      if (this._.isEmpty(reservationData)) {
        this.reservationData =
          await this.reservationService.getReservationDetails({
            reservationID:
              this.activatedRoute.snapshot.paramMap.get("reservationID"),
            busDetail: 1,
            emailDetail: 0,
          });
      } else {
        this.reservationData = reservationData;
      }

      for (let item of this.reservationData.reservation.passenger_list) {
        item.board_initial = item.board;
      }
    }

    /* CHECK IF RESERVATION IS VALID */
    let cancelDeadlineTime = this.moment(
      this.reservationData.reservation.dpt_ymd,
      "YYYY/MM/DD"
    )
      .subtract(this.reservationData.reservation.bus_detail.c_close_day, "days")
      .add(this.reservationData.reservation.bus_detail.c_close_hour, "hours")
      .valueOf();

    let currentServerTime = this.moment(
      this.moment()
        .utc()
        .add(this.commonService.appConfig.server.timeZoneOffset, "hours")
        .format("YYYY-MM-DD HH:mm:ss")
    ).valueOf();

    if (
      this.reservationData.reservation.reservation_id &&
      this.reservationData.reservation.booking_status !==
        this.commonService.appConfig.reservation.bookingStatus.cancelled &&
      cancelDeadlineTime > currentServerTime
    ) {
      /* DO NOTHING */
    } else {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationDetailNoParam,
        [this.reservationData.reservation.reservation_id]
      );
    }

    /* INIT FORM DATA */
    this.initFormData();

    if (this._.isEmpty(this.reservationData.reservation)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationListNoParam
      );
    }

    /* CALCULATE ALIGHTING DAY */
    this.reservationData.reservation.alightingDay =
      this.reservationData.reservation.dpt_ymd;

    if (this.reservationData.reservation.station_list) {
      let firstTime =
        this.reservationData.reservation.station_list[0].station_time;
      firstTime = parseInt(firstTime.replace(":", ""));

      let lastTime =
        this.reservationData.reservation.station_list[1].station_time;
      lastTime = parseInt(lastTime.replace(":", ""));

      if (firstTime > lastTime) {
        this.reservationData.reservation.alightingDay = this.moment(
          this.reservationData.reservation.alightingDay
        )
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
    }

    /* CALCULATE PASSENGER */
    this.reservationData.reservation.passenger = {
      adult: {
        men: 0,
        women: 0,
        total: 0,
      },
      children: {
        men: 0,
        women: 0,
        total: 0,
      },
    };

    let totalCancels = 0;
    for (let passenger of this.reservationData.reservation.passenger_list) {
      if (
        passenger.price_type ==
        this.commonService.appConfig.reservation.priceType.adult
      ) {
        /* ADULT */
        if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          this.reservationData.reservation.passenger.adult.men++;
        } else if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexFemale
        ) {
          this.reservationData.reservation.passenger.adult.women++;
        }
      } else if (
        passenger.price_type ==
        this.commonService.appConfig.reservation.priceType.children
      ) {
        /* CHILDREN */
        if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          this.reservationData.reservation.passenger.children.men++;
        } else if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexFemale
        ) {
          this.reservationData.reservation.passenger.children.women++;
        }
      }

      /* COUNTER */
      if (
        passenger.board ==
        this.commonService.appConfig.reservation.passengerBoarding.cancelled
      ) {
        totalCancels++;
      }
    }
    this.reservationData.reservation.passenger.adult.total =
      this.reservationData.reservation.passenger.adult.men +
      this.reservationData.reservation.passenger.adult.women;
    this.reservationData.reservation.passenger.children.total =
      this.reservationData.reservation.passenger.children.men +
      this.reservationData.reservation.passenger.children.women;
    this.reservationData.reservation.seatChangeable =
      this.reservationData.reservation.booking_status !==
        this.commonService.appConfig.reservation.bookingStatus.cancelled &&
      cancelDeadlineTime > currentServerTime
        ? true
        : false;
    this.reservationData.reservation.changeable =
      this.reservationData.reservation.seatChangeable &&
      totalCancels < this.reservationData.reservation.passenger_list.length - 1
        ? true
        : false;
    this.reservationData.reservation.boardChangeable =
      this.reservationData.reservation.source_id ==
      this.commonService.appConfig.plan.sources.keio 
      || this.reservationData.reservation.source_id == 
      this.commonService.appConfig.plan.sources.kobo
        ? false
        : true;
    this.reservationData.reservation.stationChangeable =
      this.reservationData.reservation.source_id ==
      this.commonService.appConfig.plan.sources.keio 
      || this.reservationData.reservation.source_id == 
      this.commonService.appConfig.plan.sources.kobo
        ? false
        : true;
    /* END */

    /* SET CURRENT ITEM & LAST ITEM OF CANCEL LIST */
    let firstItem = this.reservationData.reservation.bus_detail.cancel_list[0];
    if (firstItem && firstItem.price) {
      this.currentCancelRuleItem = {
        ...firstItem,
        rate: `${firstItem.price}円`,
      };
    } else {
      this.currentCancelRuleItem = { id: 0, name: "無し", rate: 0 };
    }
    this.reservationData.reservation.cancelList = {
      firstItem: firstItem,
      lastItem:
        this.reservationData.reservation.bus_detail.cancel_list[
          this.reservationData.reservation.bus_detail.cancel_list.length - 1
        ],
    };

    /* THE DAY BEFORE DEPARTURE DAY */
    this.reservationData.reservation.dayBeforeDepartureDay = this.moment(
      this.reservationData.reservation.dpt_ymd
    )
      .startOf("day")
      .diff(this.moment(Date.now()).startOf("day"), "days");

    /* USE INSURANCE */
    this.reservationData.reservation.useInsurance =
      this.reservationData.reservation.insurance_type ==
      this.commonService.appConfig.reservation.useInsuranceOn
        ? true
        : false;

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  initFormData() {
    let formData = {};

    for (let [
      index,
      item,
    ] of this.reservationData.reservation.passenger_list.entries()) {
      let idx = index + 1;

      formData[`p_representative_${idx}`] = [
        parseInt(item.is_representative),
        [Validators.required],
      ];

      formData[`p_mei_${idx}`] = [
        item.mei_kana,
        [Validators.required, this.myValidator.isKana],
      ];
      formData[`p_sei_${idx}`] = [
        item.sei_kana,
        [Validators.required, this.myValidator.isKana],
      ];

      /* AGE */
      this.tempData.maxAge =
        item.price_type ==
        this.commonService.appConfig.reservation.priceType.children
          ? this.commonService.appConfig.reservation.passengerAgeLimit
              .childrenMax
          : this.commonService.appConfig.reservation.passengerAgeLimit.max;
      formData[`p_age_${idx}`] = [
        parseInt(item.age),
        [
          Validators.required,
          this.myValidator.isNumeric,
          this.myValidator.minAge,
          Validators.max(this.tempData.maxAge),
        ],
      ];
      /* END */

      /* SEX */
      let sex = item.sex
        ? parseInt(item.sex)
        : this.commonService.appConfig.reservation.defaultUserData.sexMale;
      formData[`p_sex_${idx}`] = [
        sex,
        [Validators.required, this.myValidator.menOrWomenOnly(index)],
      ];
      /* END */

      formData[`p_board_${idx}`] = [
        parseInt(item.board),
        [Validators.required],
      ];
      formData[`p_board_initial_${idx}`] = parseInt(
        item.board_initial
      ); /* FOR DO BUSINESS CODE ONLY */

      formData[`p_tel1_${idx}`] = item.tel1 ? item.tel1 : "";
      formData[`p_tel2_${idx}`] = item.tel2 ? item.tel2 : "";
      formData[`p_tel3_${idx}`] = item.tel3 ? item.tel3 : "";
      formData[`p_tel_${idx}`] = [
        `${formData[`p_tel1_${idx}`]}${formData[`p_tel2_${idx}`]}${
          formData[`p_tel3_${idx}`]
        }`,
        [
          this.myValidator.isNumeric,
          this.myValidator.representativePhone(index),
        ],
      ];
    }

    this.formGroup = this.formBuilder.group(formData);
  }

  async onSubmit() {
    this.tempData.formSubmitted = true;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.formGroup);

    /* CHECK VALID INPUTS */
    if (this.formGroup.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error-msg:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop:
              this.$(".form-error-msg:visible").first().offset().top - 90,
          },
          200
        );
      }
      return false;
    }

    /* RE-SET TEL */
    for (let [
      index,
      item,
    ] of this.reservationData.reservation.passenger_list.entries()) {
      if (
        this.formGroup.controls[`p_representative_${index + 1}`].value ==
        this.commonService.appConfig.reservation.passengerRepresentative
      ) {
        let telParts = this.commonService.getBBTelParts(
          this.formGroup.controls[`p_tel_${index + 1}`].value
        );
        this.formGroup.controls[`p_tel1_${index + 1}`].setValue(telParts[0]);
        this.formGroup.controls[`p_tel2_${index + 1}`].setValue(telParts[1]);
        this.formGroup.controls[`p_tel3_${index + 1}`].setValue(telParts[2]);
      } else {
        this.formGroup.controls[`p_tel1_${index + 1}`].setValue("");
        this.formGroup.controls[`p_tel2_${index + 1}`].setValue("");
        this.formGroup.controls[`p_tel3_${index + 1}`].setValue("");
        this.formGroup.controls[`p_tel_${index + 1}`].setValue("");
      }
    }
    /* END */

    /* SAVE CHANGES DATA */
    let changesData = {
      reservationData: this.reservationData,
      passengerChangeData: this.formGroup.value,
    };
    this.reservationService.saveReservationChangesData(changesData);

    /* SET SUBMITTING FLAG ONCE FOR CONFIRM PAGE */
    this.commonService.setData("onSubmitReservationChanging", true);

    /* REDIRECT TO NEXT PAGE */
    this.commonService.redirectToRoute(
      this.commonService.routePaths.pageReservationConfirmNoParam,
      [this.reservationData.reservation.reservation_id]
    );
  }

  changeRepresentative(event: any) {
    let selectedIndex = event.target.value;
    /* DEACTIVE ALL */
    for (let [
      index,
      item,
    ] of this.reservationData.reservation.passenger_list.entries()) {
      this.formGroup.controls[`p_representative_${index + 1}`].setValue(0);
      this.formGroup.controls[`p_tel_${index + 1}`].setValue(
        this.formGroup.controls[`p_tel_${index + 1}`].value
      );
    }
    /* SET ACTIVE THE CHOSEN */
    this.formGroup.controls[`p_representative_${selectedIndex}`].setValue(
      this.commonService.appConfig.reservation.passengerRepresentative
    );
    this.formGroup.controls[`p_tel_${selectedIndex}`].setValue(
      this.formGroup.controls[`p_tel_${selectedIndex}`].value
    );

    /* RE-INIT INPUT ZEN TO HAN */
    this.commonService.zenToHan();
  }

  changeInputValue(event: any, inputName: any) {
    this.formGroup.controls[inputName].setValue(event.target.value);
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  setStation(type = "", index = -1) {
    if (
      !this.reservationData.reservation.seatChangeable ||
      !this.reservationData.reservation.stationChangeable
    ) {
      return false;
    }

    switch (type) {
      case "departure":
        this.reservationData.reservation.station_list[0] =
          this.reservationData.reservation.bus_detail.station_list[index];
        break;

      case "destination":
        this.reservationData.reservation.bus_detail.station_list[
          index
        ].station_code =
          this.reservationData.reservation.bus_detail.station_list[
            index
          ].station_id;
        this.reservationData.reservation.station_list[1] =
          this.reservationData.reservation.bus_detail.station_list[index];
        break;
    }
  }

  showWarning(title: string = "", message: string = "") {
    this.tempData.warningModal = {
      title: title,
      message: message,
    };
    this.$("#warningModal").modal();
  }

  inlineJS() {
    let self = this;
    this.$(document).ready(function () {
      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
    });
  }

  async warningChangeModal(){
    let checkReservationData: any = {};
    checkReservationData = await this.reservationService.findReservationByID({
      reservationID: this.activatedRoute.snapshot.paramMap.get("reservationID"),
      tel: this.reservationData.userData.tel1+this.reservationData.userData.tel2+this.reservationData.userData.tel3,
      busDetail: 1,
      emailDetail: 1,
    });

    let check_param = true;

    for (let i = 0; i < checkReservationData.reservation.passenger_list.length; i++) {
      let tel = checkReservationData.reservation.passenger_list[i].tel1 + checkReservationData.reservation.passenger_list[i].tel2 + checkReservationData.reservation.passenger_list[i].tel3;
      if (
        checkReservationData.reservation.passenger_list[i].sei_kana != this.formGroup.value[`p_sei_${(i + 1)}`]
        || checkReservationData.reservation.passenger_list[i].mei_kana != this.formGroup.value[`p_mei_${(i + 1)}`]
        || checkReservationData.reservation.passenger_list[i].age != this.formGroup.value[`p_age_${(i + 1)}`]
        || checkReservationData.reservation.passenger_list[i].board != this.formGroup.value[`p_board_${(i + 1)}`]
        || checkReservationData.reservation.passenger_list[i].is_representative != this.formGroup.value[`p_representative_${(i + 1)}`]
        || checkReservationData.reservation.passenger_list[i].sex != this.formGroup.value[`p_sex_${(i + 1)}`]
        || tel != this.formGroup.value[`p_tel_${(i + 1)}`]
        || (checkReservationData.reservation.station_list[0] && checkReservationData.reservation.station_list[0].station_code) != (this.reservationData.reservation.station_list[0] && this.reservationData.reservation.station_list[0].station_code)
        || (checkReservationData.reservation.station_list[1] && checkReservationData.reservation.station_list[1].station_code) != (this.reservationData.reservation.station_list[1] && this.reservationData.reservation.station_list[1].station_code)
      ) {
        check_param = false;
      }
    }

    if(check_param){
      this.$("#warningChangeModal").modal();
    } else {
      this.onSubmit();
    }
    return true;
  }
}
